// 공지사항 빈 상태 컴포넌트
import { Bell } from 'lucide-react';
import type { AnnouncementTranslations } from './types';

interface AnnouncementEmptyStateProps {
  translations: AnnouncementTranslations;
}

export function AnnouncementEmptyState({ translations }: AnnouncementEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-32 text-center">
      <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-3">
        <Bell className="w-8 h-8 text-muted-foreground" />
      </div>
      <p className="text-[13px] text-muted-foreground">{translations.noAnnouncements}</p>
    </div>
  );
}
